export const EXECUTION_LOG_STATUS = [
  'failed',
  'partial',
  'pending',
  'success',
] as const;

export const EXECUTION_LOG_TRIGGER_SOURCE = [
  'billed',
  'manual',
  'process_state_change',
  'rerun',
] as const;
